import cn from 'classnames';
import React, { forwardRef } from 'react';

import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';
import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';
import DrawerCloseButton from '@/ebat/components/blocks/Header/MenuComponents/Drawer/DrawerCloseButton/DrawerCloseButton';
import {
  MENU_NAME_PRODUCTS,
  useHeaderMenuContext,
} from '@/ebat/contexts/Header/HeaderMenuContext/HeaderMenuContext';

const DrawerContainer = forwardRef((props, ref) => {
  const { children, className } = props;
  const { name } = useHeaderMenuContext();
  const withCloseButton = name === MENU_NAME_PRODUCTS;

  return (
    <div
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...props}
      className={cn(className, 'rs-header-drawer-wrapper')}
      ref={ref}
    >
      {withCloseButton && <DrawerCloseButton />}
      {children}
    </div>
  );
});

DrawerContainer.defaultProps = {
  ...ClassNameDefaultProps,
  ...ChildrenDefaultProps,
};

DrawerContainer.propTypes = {
  ...ClassNamePropTypes,
  ...ChildrenPropTypes,
};

export default DrawerContainer;
